module.exports = __webpack_public_path__ + "d8b41adc340200513ea35692d63c1e5b.png";